module.exports = "https://static.zego.com/_next/static/images/CustomerService-a9742680b2b359bcc07e3c80c28cc3a6.svg";